import { $ } from "@/common/Axios";

export default {
  /**
   * 志愿调整
   */
  volunteerTransfer_agree: {
    /*
     * 是否同意
     * id id (integer query required)
     * agreeType 是否统一 (string query required)
     * remark 备注 (string query )
     */
    put: (p, c) => $.put("/api/ems/adultexam/volunteerTransfer/agree", p, c),
  },
  volunteerTransfer: {
    /*
     * 添加
     * transfer  ( query required)
     */
    post: (p, c) => $.post("/api/ems/adultexam/volunteerTransfer", p, c),
  },
  volunteerTransfer_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ems/adultexam/volunteerTransfer/upload", p, c),
  },
  volunteerTransfer_syncTransfers: {
    /*
     * 同步调剂(补报)
     * zkzh 准考证号 (string query )
     * name 准考证号 (string query )
     * col1zy1RefOwid 专业代码id (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/volunteerTransfer/syncTransfers", p, c),
  },
  volunteerTransfer_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/adultexam/volunteerTransfer/list", p, c),
  },
  volunteerTransfer_listColumn: {
    /*
     * 字段列表
     * type 类型：调剂、补报 (string query )
     * key key (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/volunteerTransfer/listColumn", p, c),
  },
  volunteerTransfer_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/adultexam/volunteerTransfer/export", p, c),
  },

  /**
   * 成考信息
   */
  studentAdultExamInfo_updateItemContent: {
    /*
     * 编辑附件（类型：加分附件、免试附件、特殊证件、毕业证书照片或电子注册备案表图片；本地批量选择文件夹导入，命名方式合同编号）
     * idCardNo 身份证号 (string query required)
     * year 成考年度 (string query required)
     * type 类型：加分附件、免试附件、特殊证件、毕业证书照片或电子注册备案表图片 (string query required)
     * itemContent 附件地址 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/studentAdultExamInfo/updateItemContent", p, c),
  },
  studentAdultExamInfo_updateInfo: {
    /*
     * 编辑学生资料
     * id 列表id (integer query required)
     * area 成考考区 (string query )
     * city 地级市 (string query )
     * remark 成考备注 (string query )
     * localType 成考所在地类型:未知、本地、社保、居住证、三无 (string query )
     * localContent 成考外地凭证内容，类型为本地时不填，为社保、居住证时候上传截图，三无时填写备注 (string query )
     * addScoreItem 加分类型 (string query )
     * addScoreItemContent 加分附件 (string query )
     * notNeedExamItem 免试类型 (string query )
     * notNeedExamItemContent 免试附件 (string query )
     * diplomaPhoto 毕业证书 (string query )
     * shippingAddress 收件地址 (string query )
     * workingCertificatePhoto 工作证明 (string query )
     * educationNetCertificatePhoto 备案表 (string query )
     * educationNetCertificateImage 备案表图片 (string query )
     * educationNetCertificateNo 备案表在线验证码 (string query )
     * graduationSchool 毕业院校 (string query )
     * educationLevel 毕业层次 (string query )
     * graduationMajor 毕业专业 (string query )
     * graduationTime 毕业时间 (string query )
     * diplomaNo 毕业证书编号 (string query )
     * preDegreeStatus 前置学历毕业状态 (string query )
     * certificatePhoto 药学或护理执业证书 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/studentAdultExamInfo/updateInfo", p, c),
  },
  studentAdultExamInfo_passByFeeImage: {
    /*
     * 缴费通过
     * year 成考年度 (string query required)
     * idCardNo 身份证号 (string query required)
     * feeImage 缴费截图 (string query )
     * feePayer 缴款人 (string query required)
     * feeOrderNo 缴款单号 (string query required)
     * feeTransactionNo 交易流水号 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/studentAdultExamInfo/passByFeeImage", p, c),
  },
  studentAdultExamInfo_confirmInfo: {
    /*
     * 确认学生资料
     * id 学生资料id (integer query required)
     * status 通过1,拒绝0 (integer query required)
     * refuseReason 拒绝理由 (string query )
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/studentAdultExamInfo/confirmInfo", p, c),
  },
  studentAdultExamInfo_assignAdminTeacher: {
    /*
     * 分配合同负责人
     * schoolRollId 合同编号 (integer query required)
     * newAdminId 负责人 (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/studentAdultExamInfo/assignAdminTeacher", p, c),
  },
  studentAdultExamInfo_uploadStudentInfo: {
    /*
     * 导入学生资料
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/studentAdultExamInfo/uploadStudentInfo", p, c),
  },
  studentAdultExamInfo_uploadCodeForTransfer: {
    /*
     * 导入成考报名转专业
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/adultexam/studentAdultExamInfo/uploadCodeForTransfer",
        p,
        c
      ),
  },
  studentAdultExamInfo_updateLocalContent: {
    /*
     * 批量导入更新社保或居住证
     * year 成考年度 (string query required)
     * idCardNo 身份证 (string query required)
     * url 图片地址 (string query required)
     */
    post: (p, c) =>
      $.post(
        "/api/ems/adultexam/studentAdultExamInfo/updateLocalContent",
        p,
        c
      ),
  },
  studentAdultExamInfo_list: {
    /*
     * 学历教育-成考管理-学生资料列表
     */
    get: (p, c) => $.get("/api/ems/adultexam/studentAdultExamInfo/list", p, c),
  },
  studentAdultExamInfo_listTotalData: {
    /*
     * 成考统计-列表
     * year 成考年度（列表选择） (string query required)
     * enrollDepartmentIds 招生部门 (array query )
     * businessDepartmentIds 服务事业部 (array query )
     * departmentId 服务部门 (integer query )
     * province 学校省份 (string query )
     * previousFlag 是否往届生(全部、是、否, 选是否的时候下载) (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/listTotalData", p, c),
  },
  studentAdultExamInfo_listStatics: {
    /*
     * 成考统计-列表顶部统计
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/listStatics", p, c),
  },
  studentAdultExamInfo_listForRedeem: {
    /*
     * 待挽回列表
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/listForRedeem", p, c),
  },
  studentAdultExamInfo_listForPeer: {
    /*
     * 基础平台-同行管理-成考学生列表
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/listForPeer", p, c),
  },
  studentAdultExamInfo_listForEnrollTeacher: {
    /*
     * 招生管理-成考学生（招生老师角度）
     */
    get: (p, c) =>
      $.get(
        "/api/ems/adultexam/studentAdultExamInfo/listForEnrollTeacher",
        p,
        c
      ),
  },
  studentAdultExamInfo_getAdultExamShowInfoForApp: {
    /*
     * 成考宝典-我的成考信息
     * month 月份 (integer query )
     */
    get: (p, c) =>
      $.get(
        "/api/ems/adultexam/studentAdultExamInfo/getAdultExamShowInfoForApp",
        p,
        c
      ),
  },
  studentAdultExamInfo_export: {
    /*
     * 学历教育-成考管理-学生资料导出
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/export", p, c),
  },
  studentAdultExamInfo_exportForTotal: {
    /*
     * 成考统计-下载(是否包含往届生选择是的时候,点总数下载)
     * year 成考年度（列表选择） (string query required)
     * enrollDepartmentIds 招生部门 (array query )
     * businessDepartmentIds 服务事业部 (array query )
     * departmentId 服务部门 (integer query )
     * province 学校省份 (string query )
     * previousFlag 是否往届生(全部、是、否, 选是否的时候下载) (string query required)
     * step 阶段 (string query )
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/exportForTotal", p, c),
  },
  studentAdultExamInfo_exportForPeer: {
    /*
     * 基础平台-同行管理-成考学生导出
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/exportForPeer", p, c),
  },
  studentAdultExamInfo_exportForEnrollTeacher: {
    /*
     * 招生管理-成考学生（招生老师角度）-导出
     */
    get: (p, c) =>
      $.get(
        "/api/ems/adultexam/studentAdultExamInfo/exportForEnrollTeacher",
        p,
        c
      ),
  },
  studentAdultExamInfo_examIdCard: {
    /*
     * 准考证信息
     * year 成考年度 (string query required)
     * name 姓名 (string query required)
     * idCardNo 身份证号 (string query required)
     * examIdCard 准考证 (string query required)
     * examIdCardNo 准考证号 (string query required)
     * examAddress 考试地址 (string query required)
     * examArea 考点 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/examIdCard", p, c),
  },
  studentAdultExamInfo_enrollHelperDetail: {
    /*
     * 报名辅助页面
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/enrollHelperDetail", p, c),
  },
  studentAdultExamInfo_downloadMould: {
    /*
     * 下载模板
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/downloadMould", p, c),
  },
  studentAdultExamInfo_detail: {
    /*
     * 学生资料详情
     * id id (integer query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentAdultExamInfo/detail", p, c),
  },

  /**
   * 分数线
   */
  scoreLine_syncHbtLowestScore: {
    /*
     * 测试-同步华博特内部学生最低分数线
     * year 成考年度 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/scoreLine/syncHbtLowestScore", p, c),
  },
  scoreLine: {
    /*
     * 添加
     * scoreLine  ( query required)
     */
    post: (p, c) => $.post("/api/ems/adultexam/scoreLine", p, c),
  },
  scoreLine_listPage: {
    /*
     * 分数线列表
     */
    get: (p, c) => $.get("/api/ems/adultexam/scoreLine/listPage", p, c),
  },
  scoreLine_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/adultexam/scoreLine/export", p, c),
  },

  /**
   * 成考空报
   */
  adultExamEmpty_updateStatus: {
    /*
     * 报名人编辑状态（缴费状态或报名状态）
     * id 空报id (integer query required)
     * type 类型：缴费状态或报名状态 (string query required)
     * status 状态 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/adultExamEmpty/updateStatus", p, c),
  },
  adultExamEmpty_updatePhoto: {
    /*
     * 批量导入更新照片（身份证命名）
     * year 成考年度 (string query required)
     * idCardNo 身份证 (string query required)
     * type 类型：个人照、毕业证照片、备案表照片 (string query required)
     * photo 照片地址 (string query required)
     */
    put: (p, c) => $.put("/api/ems/adultexam/adultExamEmpty/updatePhoto", p, c),
  },
  adultExamEmpty_remark: {
    /*
     * 备注
     * id 空报id (integer query required)
     * remark 备注 (string query required)
     */
    put: (p, c) => $.put("/api/ems/adultexam/adultExamEmpty/remark", p, c),
  },
  adultExamEmpty_passByFeeImage: {
    /*
     * 缴费通过
     * year 成考年度 (string query required)
     * idCardNo 身份证号 (string query required)
     * feeImage 缴费截图 (string query )
     * feePayer 缴款人 (string query required)
     * feeOrderNo 缴款单号 (string query required)
     * feeTransactionNo 交易流水号 (string query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/adultExamEmpty/passByFeeImage", p, c),
  },
  adultExamEmpty_assignEnroll: {
    /*
     * 分配报名人
     * ids 空报id (array query required)
     * enrollId 报名人id (integer query required)
     */
    put: (p, c) =>
      $.put("/api/ems/adultexam/adultExamEmpty/assignEnroll", p, c),
  },
  adultExamEmpty: {
    /*
     * 添加
     * empty  ( query required)
     */
    post: (p, c) => $.post("/api/ems/adultexam/adultExamEmpty", p, c),
  },
  adultExamEmpty_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) => $.post("/api/ems/adultexam/adultExamEmpty/upload", p, c),
  },
  adultExamEmpty_list: {
    /*
     * 空报列表
     */
    get: (p, c) => $.get("/api/ems/adultexam/adultExamEmpty/list", p, c),
  },
  adultExamEmpty_listForInner: {
    /*
     * 空报列表-内部管理
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/adultExamEmpty/listForInner", p, c),
  },
  adultExamEmpty_getApplyInfo: {
    /*
     * 获取报名信息（报名辅助页面）
     * year 成考年度 (string query required)
     * idCardNo 身份证号码 (string query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/adultExamEmpty/getApplyInfo", p, c),
  },
  adultExamEmpty_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/adultexam/adultExamEmpty/export", p, c),
  },

  /**
   * 学生分数
   */
  studentOfficeScore_uploadScore: {
    /*
     * 上传成绩
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/studentOfficeScore/uploadScore", p, c),
  },
  studentOfficeScore_saveScore: {
    /*
     * 保存成绩
     * userName 姓名 (string query required)
     * zkzh 准考证号 (string query required)
     * subjectTitles 课程名称 (array query required)
     * subjectGrades 课程成绩 (array query required)
     */
    get: (p, c) =>
      $.get("/api/ems/adultexam/studentOfficeScore/saveScore", p, c),
  },
  studentOfficeScore_list: {
    /*
     * 成绩列表
     * year 成考年度 (string query required)
     * idCardNo 身份证 (string query required)
     */
    get: (p, c) => $.get("/api/ems/adultexam/studentOfficeScore/list", p, c),
  },

  /**
   * 成考官方信息
   */
  officialInfo_uploadAdmission: {
    /*
     * 上传录取名单
     * file  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/officialInfo/uploadAdmission", p, c),
  },
  officialInfo_saveSignInfo: {
    /*
     * 保存考试院信息
     * owid 用户id (string query required)
     * idCardNo 身份证号 (string query required)
     * name 姓名 (string query required)
     * nation 民族 (string query required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/officialInfo/saveSignInfo", p, c),
  },
  officialInfo_saveEnrollInfo: {
    /*
     * 保存报考信息
     * owid owid (string query )
     * idCardNo 身份证号 (string query )
     * zyOwid 专业 (string query )
     * state 状态 (string query required)
     * feeStatus 缴费状态 (string query required)
     * foreignTitle 语种 (string query )
     * signType 登陆类型：1：正常,2免试 (string query )
     * denyTimes 拒绝次数 (string query )
     * denyReason 拒绝理由 (string query )
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/officialInfo/saveEnrollInfo", p, c),
  },
  officialInfo_restore: {
    /*
     * 修复
     * owid owid (string query required)
     * noTrial 是否免试 (string query required)
     * state 审核状态 (string query required)
     * feeStatus 缴费状态 (string query required)
     */
    post: (p, c) => $.post("/api/ems/adultexam/officialInfo/restore", p, c),
  },

  /**
   * 成考专业代码
   */
  adultExamMajorCode: {
    /*
     * 添加
     * code  ( query required)
     */
    post: (p, c) => $.post("/api/ems/adultexam/adultExamMajorCode", p, c),

    /*
     * 删除
     * id id (integer query required)
     */
    delete: (p, c) => $.delete("/api/ems/adultexam/adultExamMajorCode", p, c),
  },
  adultExamMajorCode_upload: {
    /*
     * 导入
     * excelFile  (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/adultExamMajorCode/upload", p, c),
  },
  adultExamMajorCode_updateInfo: {
    /*
     * 更新考试院招生计划中的信息
     * file Json文件 (string body required)
     */
    post: (p, c) =>
      $.post("/api/ems/adultexam/adultExamMajorCode/updateInfo", p, c),
  },
  adultExamMajorCode_list: {
    /*
     * 列表
     */
    get: (p, c) => $.get("/api/ems/adultexam/adultExamMajorCode/list", p, c),
  },
  adultExamMajorCode_export: {
    /*
     * 导出
     */
    get: (p, c) => $.get("/api/ems/adultexam/adultExamMajorCode/export", p, c),
  },
};
